import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=0fbbeef2&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
import style0 from "./Icon.vue?vue&type=style&index=0&id=0fbbeef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbeef2",
  null
  
)

export default component.exports